/**********************************************************************
 *
 * Copyright (C) 2026 Almendo Technologies GmbH
 * Copyright (C) 2026 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
import { blusensorEnv } from '../config';

export const ENVIRONMENTS = ['prod', 'test', 'dev', 'sandbox'];

// .env.local is required (template: .env.local.example) - no detection, no fallback.
// It selects the committed backend config src/env/backend.<env>.json (see config.js).
const environment = ENVIRONMENTS.includes(blusensorEnv) ? blusensorEnv : null;

if (!environment) {
  console.error(`REACT_APP_BLUSENSOR_ENV is "${blusensorEnv}" (expected ${ENVIRONMENTS.join('/')})`);
}

const getEnvironment = () => environment;

export default getEnvironment;
